import { MessageCircle } from "lucide-react";
import { SHOP } from "@/constants";

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${SHOP.whatsapp}?text=${encodeURIComponent("Hello Utsav Flowers! I'd like to enquire about flowers / decoration.")}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-forest/20 transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle size={24} fill="currentColor" strokeWidth={0} />
    </a>
  );
}
